module.exports = __webpack_public_path__ + "static/media/temp.[p=0].ed4ee6a8.png";